module.exports = __webpack_public_path__ + "static/media/ResponPic1.9acaf45b.jpg";